<template>
  <el-drawer
    title="添加产品"
    :visible.sync="visible"
    @close="addShopStateClose"
    size="1220px"
    :close-on-click-modal="false"
    id="addShop"
  >
    <div>
      <!-- 三级分类 -->
      <div class="tabView">
        <div class="tabTitle">种类</div>
        <div v-for="(item, index) in treeData" :key="index">
          <div
            :class="tabItem.id == item.id ? 'activeTab' : 'tabItem'"
            @click="handleTabClick(item)"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
      <div class="treeWarp">
        <div v-for="(item1, index1) in treeData" :key="index1">
          <div v-show="tabItem.id === item1.id">
            <div
              v-for="(item, index) in item1.children"
              :key="index"
              class="treeView"
            >
              <div
                :class="item.id == categoryId ? 'treeActiveLeft' : 'treeLeft'"
                @click="handleTreeClick(item1, item)"
              >
                {{ item.label }}
              </div>
              <div class="treeRight">
                <div
                  :class="
                    treeItem.id == categoryId ? 'treeActiveItem' : 'treeItem'
                  "
                  v-for="(treeItem, treeIndex) in item.children"
                  :key="treeIndex"
                  @click="handleTreeClick(item1, treeItem)"
                >
                  <div>
                    {{ treeItem.label }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 搜索框 -->
      <div class="searchView">
        <el-input
          placeholder="请输入内容"
          v-model="searchValue"
          clearable
          style="width: 200px"
          size="mini"
          @clear="search"
          @keyup.enter.native="search"
        ></el-input>
        <el-button type="warning" size="mini" @click="search">搜索</el-button>
        <span
          v-if="tabItem.code === 'medical' && medicineTag.length > 0"
          style="margin-left: 30px"
        >
          <el-radio
            v-model="curTagKey"
            :label="''"
            size="mini"
            style="margin: 0 10px"
            >全部</el-radio
          >
          <span v-for="(tag, tagIndex) in medicineTag" :key="tagIndex">
            <span v-for="(tag1, tag1Index) in tag.symptom" :key="tag1Index">
              <span
                v-for="(tag2, tag2Index) in tag1.symptomLevel"
                :key="tag2Index"
              >
                <el-radio
                  v-model="curTagKey"
                  :label="tag2.key"
                  size="mini"
                  style="margin: 0 10px"
                  >{{ tag2.value }}</el-radio
                >
              </span>
            </span>
          </span>
        </span>
      </div>
      <!-- 商品列表 -->
      <div class="listBox" v-if="tabItem.code === 'goods'">
        <el-table :data="tableData0" style="width: 100%" key="goods">
          <el-table-column prop="title" label="商品名称" width="250">
            <template slot-scope="scope">
              <div v-if="$public.isNull(scope.row.cover)">
                {{ scope.row.title }}
              </div>
              <el-tooltip v-else placement="top" effect="light">
                <div slot="content">
                  <img :src="scope.row.cover" style="width: 300px" />
                </div>
                <div>{{ scope.row.title }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="类别" width="120">
            <template slot-scope="scope">
              {{ scope.row.category_info.name }}
            </template>
          </el-table-column>
          <el-table-column label="规格/条码/包装/售价/库存" width="1000">
            <template slot-scope="scope">
              <div>
                <div
                  style="display: flex; padding: 5px"
                  v-for="(item, index) in scope.row.skus_list"
                  :key="index"
                >
                  <div
                    v-if="item.status === 1"
                    class="column"
                    style=" margin-right: 50px"
                  >
                    <div>
                      <span v-if="$public.isNull(item.image)">{{
                        item.skus_name
                      }}</span>
                     
                      <el-tooltip v-else placement="top" effect="light">
                        <div slot="content" style="width: 300px;height: 300px;">
                          <img :src="item.image[0]"  style="width: 100%;height: 100%;">
                        </div>
                        <span>{{ item.skus_name }}</span>
                      </el-tooltip>
                    </div>
                   
                  </div>
                  <div v-if="item.status === 1"  style="color: black;font-size: 17px;margin: 0 10px;">{{
                        item.barcode?item.barcode:''
                      }}</div>
                  <div
                    v-if="item.status === 1"
                    class="column"
                    style="width: 200px"
                  >
                    <div
                      style="margin: 1px"
                      v-for="(item1, index1) in item.sale_way"
                      :key="index1"
                    >
                      {{ item1.packing_way_name }}
                      <el-button
                        @click="select0(scope.row, item, item1)"
                        type="warning"
                        size="mini"
                        >+选择</el-button
                      >
                      <span style="margin: 0 30px 0 0"
                        >￥{{ item1.pprice }}</span
                      >
                    </div>
                  </div>
                  <div
                    v-if="item.status === 1&&item.stock_detail[0]"
                    class="column"
                    style="
                      width: 440px;
                      margin-right: 10px;
                      flex-direction: row;
                      font-size: 12px;
                      flex-wrap: wrap;
                      justify-content: flex-start;
                    "
                  >
                    <span
                      v-for="(stockItem, index) in item.stock_detail"
                      :key="index"
                      style="margin-right: 5px"
                    >
                      <span
                        v-if="stockItem.shop_id !== ''"
                        :style="{
                          color:
                            stockItem.shop_id === shopId && shopId !== ''
                              ? '#1890FF'
                              : '#606266',
                        }"
                      >
                        {{ $public.getShopNameById(stockItem.shop_id) }}:{{
                          stockItem.stock_show_info
                        }}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="250" >
						<template slot-scope="scope">
							<span v-if="scope.row.status==-1">已作废</span>
              <span v-if="scope.row.status==1">启用中</span>
              <span v-if="scope.row.status==0">暂停</span>
						</template>
					</el-table-column>
        </el-table>
      </div>
      <!-- 虚拟列表 -->
      <div class="listBox" v-if="tabItem.code === 'virtual'">
        <el-table :data="tableData1" style="width: 100%" key="virtual">
          <el-table-column prop="title" label="名称"> </el-table-column>
          <el-table-column label="类别" width="120">
            <template slot-scope="scope">
              {{ scope.row.category_info.name }}
            </template>
          </el-table-column>
          <el-table-column label="适用服务" width="400">
            <template slot-scope="scope">
              <div class="column">
                <div
                  style="margin: 1px"
                  v-for="(item, index) in scope.row.service_details"
                  :key="index"
                >
                  <el-button
                    @click="select1(scope.row, item)"
                    type="warning"
                    size="mini"
                    >+选择</el-button
                  >
                  {{ item.service_name }} ({{ item.service_objectName }})
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="售价" width="200">
            <template slot-scope="scope">
              <div class="column">
                <div
                  style="margin: 1px; padding: 3px 0"
                  v-for="(item, index) in scope.row.service_details"
                  :key="index"
                >
                  {{ item.price }}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 活体列表 -->
      <div class="listBox" v-if="tabItem.code === 'pet'">
        <el-table :data="tableData2" style="width: 100%" key="pet">
          <el-table-column prop="title" label="名称" width="250">
          </el-table-column>
          <el-table-column label="类别" width="120">
            <template slot-scope="scope">
              {{ scope.row.category_info.name }}
            </template>
          </el-table-column>
          <el-table-column prop="title" label="颜色" width="200">
            <template slot-scope="scope">
              {{ scope.row.color }}
            </template>
          </el-table-column>
          <el-table-column label="宠物等级" width="200">
            <template slot-scope="scope">
              <div class="column">
                <div
                  style="margin: 1px 0"
                  v-for="(item, index) in scope.row.pet_level"
                  :key="index"
                >
                  <el-button
                    @click="select2(scope.row, item)"
                    type="warning"
                    size="mini"
                    >+选择</el-button
                  >
                  {{ item.stars }}星
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="售价" width="200">
            <template slot-scope="scope">
              <div class="column">
                <div
                  style="padding: 4px 5px"
                  v-for="(item, index) in scope.row.pet_level"
                  :key="index"
                >
                  {{ item.price }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="库存" width="250">
          </el-table-column>
        </el-table>
      </div>
      <!-- 医疗列表 -->
      <div class="listBox" v-if="tabItem.code === 'medical'">
        <el-table :data="tableData3" style="width: 100%" key="medical">
          <el-table-column prop="title" label="药品名称" width="350">
            <template slot-scope="scope">
              <div v-if="$public.isNull(scope.row.cover)">
                {{ scope.row.title }}
              </div>
              <el-tooltip v-else placement="top" effect="light">
                <div slot="content">
                  <img :src="scope.row.cover" style="width: 300px" />
                </div>
                <div>{{ scope.row.title }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="类别" width="120">
            <template slot-scope="scope">
              {{ scope.row.category_info.name }}
            </template>
          </el-table-column>
          <el-table-column label="规格" width="300">
            <template slot-scope="scope" v-if="scope.row.old_packinfo_info">
              {{ scope.row.old_packinfo_info.sku_value }}
              <el-button
                @click="select3(scope.row,scope.row.old_packinfo_info)"
                type="warning"
                size="mini"
                v-if="scope.row.status == 1"
                >+选择</el-button
              >
            </template>
          </el-table-column>
          <el-table-column prop="title" label="价格" width="80">
            <template slot-scope="scope"> ￥{{ scope.row.pprice }} </template>
          </el-table-column>
          <el-table-column prop="address" label="库存" width="350">
            <template slot-scope="scope">
             
              <div v-if="$public.isNull(shopId)&&scope.row.stock_detail[0]">
                <span
                  v-for="(stockItem, index) in scope.row.stock_detail"
                  :key="index"
                >
                  <span
                    v-if="stockItem.shop_id !== ''"
                    :style="{
                      color:
                        stockItem.shop_id === shopId && shopId !== ''
                          ? '#1890FF'
                          : '#606266',
                    }"
                    style="margin-right: 4px"
                  >
                    {{ $public.getShopNameById(stockItem.shop_id) }}:{{
                      stockItem.stock_show_info
                    }}
                  </span>
                </span>
              </div>
              <div v-if="!$public.isNull(shopId)&&scope.row.stock_detail[0]">
                <span  v-for="(stockItem, index) in scope.row.stock_detail"
                  :key="index"
                  style="color: #f56c6c">
                 {{ stockItem.shop_stock}} <span v-if="stockItem.stock_show_info">({{ stockItem.stock_show_info }})</span>
                </span>
          
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 生活服务列表 -->
      <div class="listBox" v-if="tabItem.code === 'lifeservice'">
        <el-table :data="tableData4" style="width: 100%" key="lifeservice">
          <el-table-column prop="title" label="服务名称"> </el-table-column>
          <el-table-column label="类别" width="120">
            <template slot-scope="scope">
              {{ scope.row.category_info.name }}
            </template>
          </el-table-column>
          <el-table-column prop="title" label="规格" width="300">
            <template slot-scope="scope">
              <div class="column">
                <div
                  style="margin: 1px"
                  v-for="(item, index) in scope.row.serviceItems"
                  :key="index"
                >
                  <el-button
                    @click="select4(scope.row, item)"
                    type="warning"
                    size="mini"
                    >+选择</el-button
                  >
                  {{ item.extend_attr }} {{ item.service_objectName }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="售价" width="200">
            <template slot-scope="scope">
              <div class="column">
                <div
                  style="margin: 1px"
                  v-for="(item, index) in scope.row.serviceItems"
                  :key="index"
                >
                  ￥{{ item.price }}/{{ item.frequency_text }}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 医疗服务列表 -->
      <div class="listBox" v-if="tabItem.code === 'medicalservice'">
        <el-table :data="tableData5" style="width: 100%" key="medicalservice">
          <el-table-column prop="title" label="服务名称"> </el-table-column>
          <el-table-column label="类别" width="120">
            <template slot-scope="scope">
              {{ scope.row.category_info.name }}
            </template>
          </el-table-column>
          <el-table-column prop="title" label="规格" width="300">
            <template slot-scope="scope">
              <div class="column">
                <div
                  style="margin: 1px"
                  v-for="(item, index) in scope.row.serviceItems"
                  :key="index"
                >
                  <el-button
                    @click="select5(scope.row, item)"
                    type="warning"
                    size="mini"
                    >+选择</el-button
                  >
                  {{ item.service_objectName }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="售价" width="200">
            <template slot-scope="scope">
              <div class="column">
                <div
                  style="margin: 1px"
                  v-for="(item, index) in scope.row.serviceItems"
                  :key="index"
                >
                  ￥{{ item.price }}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 套餐列表 -->
      <div class="listBox" v-if="tabItem.code === 'package'">
        <el-table :data="tableData6" style="width: 100%" key="package">
          <el-table-column prop="title" label="套餐名称"> </el-table-column>
          <el-table-column label="类别" width="120">
            <template slot-scope="scope">
              {{ scope.row.category_info.name }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="title" label="规格" >
						<template>
							--
						</template>
					</el-table-column> -->
          <el-table-column label="售价">
            <template slot-scope="scope">
              <el-button @click="select6(scope.row)" type="warning" size="mini"
                >+选择</el-button
              >
              ￥{{ scope.row.total_money }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 耗材 -->
      <div class="listBox" v-if="tabItem.code === 'ConsumableMaterial'">
        <el-table
          :data="tableData7"
          style="width: 100%"
          key="ConsumableMaterial"
        >
          <el-table-column prop="title" label="耗材名称" width="350">
            <template slot-scope="scope">
              <div v-if="$public.isNull(scope.row.cover)">
                {{ scope.row.title }}
              </div>
              <el-tooltip v-else placement="top" effect="light">
                <div slot="content">
                  <img :src="scope.row.cover" style="width: 300px" />
                </div>
                <div>{{ scope.row.title }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="类别" width="120">
            <template slot-scope="scope">
              {{ scope.row.category_info.name }}
            </template>
          </el-table-column>


          <el-table-column label="规格" width="300">
            <template slot-scope="scope">
              <el-button
                @click="select7(scope.row,'',scope.row.packing_unit)"
                type="warning"
                size="mini"
                v-if="scope.row.status == 1"
                >+选择</el-button
              >
            </template>

          </el-table-column>
          <el-table-column prop="title" label="价格" width="90">
            <template> -- </template>
          </el-table-column>
          <el-table-column prop="address" label="单位" width="250">
            <template slot-scope="scope">
              {{ scope.row.packing_unit }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 分页 -->
    <page
      :page="page.page"
      :total="page.total"
      @change="changePage"
      style="padding: 10px"
    ></page>
  </el-drawer>
</template>
<script>
import page from "./page.vue";
export default {
  components: { page },
  data() {
    return {
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      otherType: "卡",
      tableData0: [],
      tableData1: [],
      tableData2: [],
      tableData3: [],
      tableData4: [],
      tableData5: [],
      tableData6: [],
      tableData7: [],
      visible: true,

      treeData: [],
      tabItem: "",
      categoryId: "",

      searchValue: "", //搜索框
      searchCategoryItem: {},
      curTagKey: "", // 药品标签
    };
  },
  computed: {},
  props: {
    addShopState: {
      //显示状态
      default: false,
    },
    shopId: {
      //
      default: "",
    },
    classType: {
      default: "0",
    },
    tree: {
      default: () => {
        return [];
      },
    },
    medicineTag: {
      // 药品标签
      default: () => {
        return [];
      },
    },
    // tree:[
    // 	{
    // 		id:'602f1e88c904d9db7ccf3bec',
    // 		children:[
    // 			{
    // 				id:'602f1e88c904d9db7ccf3bf2',
    // 				children:[
    // 					{
    // 						id:'602f1e89c904d9db7ccf3bf4',
    // 					},
    // 					{
    // 						id:'602f1e89c904d9db7ccf3bfc',
    // 					}
    // 				]
    // 			},
    // 			{
    // 				id:'602f1e89c904d9db7ccf3bfc',
    // 			}
    // 		]
    // 	},
    // 	{
    // 		id:'601d11cda93f55b5cf3ae2d1',
    // 	}
    // ]
  },
  watch: {
    // 监视状态发生改变
    addShopState() {
      this.visible = this.addShopState;
    },
    curTagKey() {
      this.getCompelte(this.searchCategoryItem);
    },
  },
  mounted() {
    this.getTree();
  },
  methods: {
    //向父组件发射关闭弹框
    addShopStateClose() {
      this.$emit("closeOn", false);
    },
    // 选中
    select0(goodsItem, skuItem, wayItem) {
      // 商品
      console.log(goodsItem, skuItem, wayItem);
      this.$emit("submit", {
        goodsItem: goodsItem,
        skuItem: skuItem,
        wayItem: wayItem,
        goodsType: 0,
      });
    },
    select1(goodsItem, skuItem) {
      if (this.otherType === "卡") {
        // 卡
        this.$emit("submit", {
          goodsItem: goodsItem,
          skuItem: skuItem,
          wayItem: "无",
          goodsType: 6,
        });
      } else if (this.otherType === "优惠券") {
        this.$emit("submit", {
          goodsItem: goodsItem,
          skuItem: skuItem,
          wayItem: "无",
          goodsType: 3,
        });
      }
    },
    select2(goodsItem, skuItem) {
      // 活体
      this.$emit("submit", {
        goodsItem: goodsItem,
        skuItem: skuItem,
        wayItem: "无",
        goodsType: 5,
      });
    },
    select3(goodsItem,skuItem) {
      // 药品
      console.log(goodsItem, "goodsItem");
      this.$emit("submit", {
        goodsItem: goodsItem,
        skuItem: skuItem,
        wayItem: '无',
        goodsType: 1,
      });
    },
    select4(goodsItem, skuItem) {
      // 生活服务
      console.log(skuItem);
      this.$emit("submit", {
        goodsItem: goodsItem,
        skuItem: skuItem,
        wayItem: "无",
        goodsType: 2,
      });
    },
    select5(goodsItem, skuItem) {
      // 医疗服务
      console.log(goodsItem, skuItem);
      this.$emit("submit", {
        goodsItem: goodsItem,
        skuItem: skuItem,
        wayItem: "无",
        goodsType: 4,
      });
    },
    select6(goodsItem) {
      // 套餐
      this.$emit("submit", {
        goodsItem: goodsItem,
        skuItem: "无",
        wayItem: "无",
        goodsType: 8,
      });
    },
    select7(goodsItem,skuItem,wayItem) {
      // 耗材
      this.$emit("submit", {
        goodsItem: goodsItem,
        skuItem: skuItem,
        wayItem: wayItem,
        goodsType: 7,
      });
    },
    // 搜索
    search() {
      this.page.page = 1;
      this.getCompelte(this.searchCategoryItem);
    },
    // 分页方法
    changePage(num) {
      this.page.page = num;
      this.getCompelte(this.searchCategoryItem);
    },
    //获取列表
    getCompelte(item) {
      let categoryStr = "";
      if (!this.$public.isNull(item.children)) {
        for (let i = 0; i < item.children.length; i++) {
          if (!this.$public.isNull(item.children[i].children)) {
            for (let a = 0; a < item.children[i].children.length; a++) {
              if (!this.$public.isNull(item.children[i].children[a].children)) {
                for (
                  let b = 0;
                  b < item.children[i].children[a].children.length;
                  b++
                ) {
                  categoryStr =
                    categoryStr +
                    item.children[i].children[a].children[b].id +
                    ",";
                }
              } else {
                categoryStr =
                  categoryStr + item.children[i].children[a].id + ",";
              }
            }
          } else {
            categoryStr = categoryStr + item.children[i].id + ",";
          }
        }
      } else {
        categoryStr = item.id + ",";
      }
      this.searchCategoryItem = item;
      categoryStr = categoryStr.substr(0, categoryStr.length - 1);
      //、、、、、、、、、、、、、、、、、 商品
      if (this.tabItem.code === "goods") {
        let params = {
          keyword: this.searchValue,
          categoryId: categoryStr,
          shopId: this.shopId,
          status: "1",
          pageIndex: this.page.page,
          pageSize: this.page.pageSize,
        };
        this.$http
          .post(process.env.VUE_APP_Url2 + "api/Product/Goods/List", params)
          .then((res) => {
            if (res.code == 0) {
              console.log(res.data.data, "商品列表");
              this.tableData0 = res.data.data;
              this.page.total = res.data.count;
            }
          });
      }
      //、、、、、、、、、、、、、、、、、 虚拟
      else if (this.tabItem.code === "virtual") {
        if (this.otherType === "卡") {
          let params = {
            keyword: this.searchValue,
            categoryId: categoryStr,
            shopId: "", // 活体不区分门店
            status: "1", // 状态,如果多个,采用','进行分割        :1正常 0禁用 -1删除
            weight: 0,
            applyType: "",
            pageIndex: this.page.page,
            pageSize: this.page.pageSize,
          };
          this.$http
            .post(
              process.env.VUE_APP_Url2 + "api/product/virtual/card/list",
              params
            )
            .then((res) => {
              if (res.code == 0) {
                this.tableData1 = res.data.data;
                this.page.total = res.data.count;
              }
            });
        } else if (this.otherType === "优惠券") {
          let params = {
            keyword: this.searchValue,
            categoryId: categoryStr,
            shopId: "", // 活体不区分门店
            status: "1", // 状态,如果多个,采用','进行分割        :1正常 0禁用 -1删除
            weight: 0,
            applyType: "",
            pageIndex: this.page.page,
            pageSize: this.page.pageSize,
          };
          this.$http
            .post(
              process.env.VUE_APP_Url2 + "api/product/virtual/coupons/list",
              params
            )
            .then((res) => {
              if (res.code == 0) {
                this.tableData1 = res.data.data;
                this.page.total = res.data.count;
              }
            });
        }
      }
      //、、、、、、、、、、、、、、、、、 活体
      else if (this.tabItem.code === "pet") {
        let params = {
          keyword: this.searchValue,
          categoryId: categoryStr,
          shopId: "", // 活体不区分门店
          status: "1", // 状态,如果多个,采用','进行分割        :1正常 0禁用 -1删除
          color: "",
          pageIndex: this.page.page,
          pageSize: this.page.pageSize,
        };
        this.$http
          .post(
            process.env.VUE_APP_Url2 + "api/product/pet/category/list",
            params
          )
          .then((res) => {
            console.log(res);
            if (res.code == 0) {
              this.tableData2 = res.data.data;
              this.page.total = res.data.count;
            }
          });
      }
      //、、、、、、、、、、、、、、、、、 医疗
      else if (this.tabItem.code === "medical") {
        let params = {
          keyword: this.searchValue,
          categoryId: categoryStr,
          shopId: this.shopId,
          status: "1", // 状态,如果多个,采用','进行分割        :1正常 0禁用 -1删除
          pageIndex: this.page.page,
          pageSize: this.page.pageSize,
          tagCode: this.curTagKey,
        };
        this.$http
          .post(process.env.VUE_APP_Url2 + "api/product/medical/list", params)
          .then((res) => {
            if (res.code == 0) {
              this.tableData3 = res.data.data;
              this.page.total = res.data.count;
            }
          });
      }
      //、、、、、、、、、、、、、、、、、 生活服务
      else if (this.tabItem.code === "lifeservice") {
        let params = {
          applytype:
            this.classType.toString() === "0" ? "" : "0," + this.classType, // 应用分类 0:通用 1:狗 2:猫
          categoryCode: "", // 分类编码washing(洗澡)beauty(美容)spa(SPA)foster(寄养)
          weight: 0, // 体重 ; 小于等于0不限制体重
          keyword: this.searchValue,
          categoryId: categoryStr,
          shopId: this.shopId,
          pageIndex: this.page.page,
          pageSize: this.page.pageSize,
        };
        this.$http
          .post(
            process.env.VUE_APP_Url2 + "api/product/service/life/list/cache",
            params
          )
          .then((res) => {
            if (res.code == 0) {
              let serviceList = [];
              for (let i = 0; i < res.data.data.length; i++) {
                let serviceObj = res.data.data[i];
                for (let a = 0; a < serviceObj.serviceItems.length; a++) {
                  let skuObj = serviceObj.serviceItems[a];
                  let service_objectName = "";
                  if (this.$public.isNull(skuObj.apply_features)) {
                    service_objectName += " ";
                  } else {
                    if (
                      skuObj.apply_features.code === "" ||
                      skuObj.apply_features.code === "0"
                    ) {
                      service_objectName += " ";
                    } else {
                      service_objectName += skuObj.apply_features.name + " ";
                    }
                  }
                  if (this.$public.isNull(skuObj.apply_varieties)) {
                    service_objectName += " ";
                  } else {
                    if (
                      skuObj.apply_varieties.code === "" ||
                      skuObj.apply_varieties.code === "0"
                    ) {
                      service_objectName += " ";
                    } else {
                      service_objectName += skuObj.apply_varieties.name + " ";
                    }
                  }
                  if (this.$public.isNull(skuObj.weight_detail)) {
                    service_objectName += " ";
                  } else {
                    if (skuObj.weight_detail.enable_weight_limit !== 1) {
                      service_objectName += " ";
                    } else {
                      service_objectName +=
                        "(" +
                        skuObj.weight_detail.min_weight +
                        "-" +
                        skuObj.weight_detail.max_weight +
                        "kg)";
                    }
                  }
                  skuObj.service_objectName = service_objectName;
                }
                serviceList.push(serviceObj);
              }
              this.tableData4 = serviceList;
              this.page.total = res.data.count;
            }
          });
      }
      //、、、、、、、、、、、、、、、、、 医疗服务
      else if (this.tabItem.code === "medicalservice") {
        let params = {
          applytype: "",
          categoryCode: "", // 分类编号 handle(处置) operation(手术) detection(检查) ward(病房) register(挂号)
          weight: 0, // 体重 ; 小于等于0不限制体重
          keyword: this.searchValue,
          categoryId: categoryStr,
          shopId: this.shopId,
          pageIndex: this.page.page,
          pageSize: this.page.pageSize,
        };
        this.$http
          .post(
            process.env.VUE_APP_Url2 + "api/product/service/medical/list/cache",
            params
          )
          .then((res) => {
            if (res.code == 0) {
              this.tableData5 = res.data.data;
              this.page.total = res.data.count;
            }
          });
      }
      //、、、、、、、、、、、、、、、、、 套餐
      else if (this.tabItem.code === "package") {
        if (this.otherType === "免疫类") {
          let params = {
            applytype: "",
            weight: 0, // 体重 ; 小于等于0不限制体重
            keyword: this.searchValue,
            categoryId: categoryStr,
            shopId: this.shopId,
            buyway: "", // 购买方式 0: 卖赠 1:折扣 2:自定义
            pageIndex: this.page.page,
            pageSize: this.page.pageSize,
          };
          this.$http
            .post(
              process.env.VUE_APP_Url2 + "api/product/group/Vaccine/list",
              params
            )
            .then((res) => {
              if (res.code == 0) {
                this.tableData6 = res.data.data;
                this.page.total = res.data.count;
              }
            });
        } else if (this.otherType === "驱虫类") {
          let params = {
            applytype: "",
            weight: 0, // 体重 ; 小于等于0不限制体重
            keyword: this.searchValue,
            categoryId: categoryStr,
            shopId: this.shopId,
            buyway: "", // 购买方式 0: 卖赠 1:折扣 2:自定义
            pageIndex: this.page.page,
            pageSize: this.page.pageSize,
          };
          this.$http
            .post(
              process.env.VUE_APP_Url2 + "api/product/group/Deworming/list",
              params
            )
            .then((res) => {
              if (res.code == 0) {
                this.tableData6 = res.data.data;
                this.page.total = res.data.count;
              }
            });
        } else if (this.otherType === "医疗类") {
          let params = {
            applytype: "",
            keyword: this.searchValue,
            categoryId: categoryStr,
            shopId: this.shopId,
            pageIndex: this.page.page,
            pageSize: this.page.pageSize,
          };
          this.$http
            .post(
              process.env.VUE_APP_Url2 + "api/product/group/service/list",
              params
            )
            .then((res) => {
              if (res.code == 0) {
                this.tableData6 = res.data.data;
                this.page.total = res.data.count;
              }
            });
        } else if (this.otherType === "组合类") {
          let params = {
            applytype: "",
            keyword: this.searchValue,
            categoryId: categoryStr,
            shopId: this.shopId,
            pageIndex: this.page.page,
            pageSize: this.page.pageSize,
          };
          this.$http
            .post(
              process.env.VUE_APP_Url2 + "api/product/group/goods/list",
              params
            )
            .then((res) => {
              if (res.code == 0) {
                this.tableData6 = res.data.data;
                this.page.total = res.data.count;
              }
            });
        }
      }
      //、、、、、、、、、、、、、、、、、 耗材
      else if (this.tabItem.code === "ConsumableMaterial") {
        let params = {
          pageIndex: this.page.page,
          pageSize: this.page.pageSize,
          keyword: this.searchValue,
          categoryId: categoryStr,
        };
        this.$http
          .post(
            process.env.VUE_APP_Url2 + "api/product/consumableMaterial/list",
            params
          )
          .then((res) => {
            // console.log('耗材',res)
            if (res.code == 0) {
              this.tableData7 = res.data.data;
              this.page.total = res.data.count;
            }
          });
      } else {
        console.log("未知分类");
      }
    },
   
    //tab切换
    handleTabClick(item) {
      if (this.tabItem.id === item.id) return;
      this.tabItem = item;
      this.page.page = 1;
      // this.searchValue='';
      this.categoryId = item.id;
      if (item.code === "virtual") {
        this.categoryId = item.children[0].id;
        if (item.children[0].id === "60210f916e6d952a3929f0ec") {
          this.otherType = "卡";
        } else if (item.children[0].id === "60210f916e6d952a3929f0f0") {
          this.otherType = "优惠券";
        }
        this.getCompelte(item.children[0]);
        return;
      }
      if (item.code === "package") {
        this.categoryId = item.children[0].id;
        if (item.children[0].id === "604323824335a2f958dc740b") {
          this.otherType = "免疫类";
        } else if (item.children[0].id === "604323824335a2f958dc740d") {
          this.otherType = "驱虫类";
        } else if (item.children[0].id === "604323824335a2f958dc740f") {
          this.otherType = "医疗类";
        } else if (item.children[0].id === "604323834335a2f958dc7412") {
          this.otherType = "组合类";
        }
        this.getCompelte(item.children[0]);
        return;
      }
      this.getCompelte(item);
    },
    //点击三级分类
    handleTreeClick(item1, item) {
      if (this.categoryId === item.id) {
        console.log(item1);
        // this.handleTabClick(item1)
        // this.categoryId = item1.id
        return;
      }
      this.page.page = 1;
      // this.searchValue='';
      this.categoryId = item.id;
      if (
        item.id === "60210f916e6d952a3929f0ed" ||
        item.id === "60210f916e6d952a3929f0ee" ||
        item.id === "60210f916e6d952a3929f0ef"
      ) {
        this.otherType = "卡";
      } else if (
        item.id === "60210f916e6d952a3929f0f1" ||
        item.id === "60210f916e6d952a3929f0f2"
      ) {
        this.otherType = "优惠券";
      } else if (
        item.id === "604323824335a2f958dc740b" ||
        item.id === "604323824335a2f958dc740c"
      ) {
        this.otherType = "免疫类";
      } else if (
        item.id === "604323824335a2f958dc740d" ||
        item.id === "604323824335a2f958dc740e"
      ) {
        this.otherType = "驱虫类";
      } else if (
        item.id === "604323824335a2f958dc740f" ||
        item.id === "604323824335a2f958dc7410" ||
        item.id === "604323834335a2f958dc7411"
      ) {
        this.otherType = "医疗类";
      } else if (
        item.id === "604323834335a2f958dc7412" ||
        item.id === "604323834335a2f958dc7413" ||
        item.id === "604323834335a2f958dc7414"
      ) {
        this.otherType = "组合类";
      }
      this.getCompelte(item);
    },
    //获取所有树形结构数据
    getTree() {
      let params = {
        category: "商品,医疗,虚拟,活体,生活服务,医疗服务,套餐,耗材",
      };
      this.$http.get("/api/Product/Category/Tree", params).then((res) => {
        console.log("所有商品", res);
        if (res.code == 0) {
          // for(let i=0;i<res.data.length;i++){
          // 	if(res.data[i].id==='604323824335a2f958dc740a'){
          // 		let obj = {id:res.data[i].id,islock:res.data[i].islock,label:res.data[i].label,code:res.data[i].code,children:[]}
          // 		for(let a=0;a<res.data[i].children.length;a++){
          // 			if(res.data[i].children[a].id==='604323834335a2f958dc7412'){
          // 				obj.children.push(res.data[i].children[a])
          // 			}
          // 		}
          // 		res.data[i] = obj;
          // 	}
          // }
          if (this.tree === []) {
            this.treeData = res.data;
          } else {
            var firstTree = this.handleChild(res.data, this.tree);
            firstTree.map((tree1) => {
              this.tree.map((limit1) => {
                // console.log(limit1)
                if (tree1.id == limit1.id) {
                  tree1.children = this.handleChild(
                    tree1.children,
                    limit1.children
                  );
                  tree1.children.map((tree2) => {
                    if (
                      !Object.prototype.hasOwnProperty.call(
                        limit1,
                        "children"
                      ) ||
                      limit1.children == null ||
                      limit1.children.length == 0
                    ) {
                      tree2.children = this.handleChild(tree2.children, null);
                    } else {
                      limit1.children.map((limit2) => {
                        if (tree2.id == limit2.id) {
                          tree2.children = this.handleChild(
                            tree2.children,
                            Object.prototype.hasOwnProperty.call(
                              limit2,
                              "children"
                            )
                              ? limit2.children
                              : null
                          );
                        }
                      });
                    }
                  });
                }
              });
            });
            this.treeData = firstTree;
          }
          // this.tabItem = this.treeData[0];
          // this.handleTreeClick(this.treeData[0].children[0])
          // this.handleTreeClick({},{children:this.treeData})
          this.handleTabClick(this.treeData[0]);
        }
      });
    },
    handleChild(arr1, arr2) {
      var result = arr1;
      if (arr2 != null && arr2.length > 0) {
        result = arr1.filter((value) => {
          return arr2.some((item) => {
            return item.id == value.id;
          });
        });
      }
      return result;
    },
    // 处理门店库存
    FShopStock(arr) {
      let stock = -1;
      let open_count = 0;
      let open_lastTotalTimes = 0;
      let noUse_count = 0;
      let noUse_totalTimes = 0;
      if (!this.$public.isNull(arr)) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].shop_id === this.shopId) {
            stock = arr[i].shop_stock;
            open_count = arr[i].open_count;
            open_lastTotalTimes = arr[i].open_lastTotalTimes;
            noUse_count = arr[i].noUse_count;
            noUse_totalTimes = arr[i].noUse_totalTimes;
          }
        }
      }
      return [
        stock,
        open_count,
        open_lastTotalTimes,
        noUse_count,
        noUse_totalTimes,
      ];
    },
  },
};
</script>

<style scoped lang="scss">
#addShop {
  ::v-deep .el-drawer__header {
    margin-bottom: 10px;
  }
  ::v-deep .el-drawer__body {
    height: calc(100% - 55px);
    overflow-y: auto;
  }
}

.tabView:hover {
  cursor: pointer;
}

.tabView {
  font-size: 16px;
  color: #2a2a2a;
  font-weight: bold;
  display: flex;
  width: 100%;
  border-bottom: solid 2px #f5f5f5;

  .tabTitle {
    width: 80px;
    margin-right: 50px;
    text-align: right;
    line-height: 40px;
  }

  .tabItem {
    margin-right: 40px;
    line-height: 40px;
    box-sizing: border-box;
  }

  .activeTab {
    margin-right: 40px;
    line-height: 40px;
    box-sizing: border-box;
    border-bottom: solid 2px $mainColor;
  }
}

.treeWarp:hover {
  cursor: pointer;
}

.treeWarp {
  padding-top: 10px;
  font-size: 14px;
  color: #2a2a2a;
  overflow: hidden;

  .treeView {
    display: flex;
    margin-bottom: 10px;
    overflow: hidden;

    .treeLeft {
      width: 80px;
      margin-right: 44px;
      text-align: right;
      padding: 4px 0;
    }
    .treeActiveLeft {
      width: 80px;
      margin-right: 44px;
      text-align: right;
      padding: 4px 0;
      // background: $mainColor;
      // color: #fff;
      color: $mainColor;
    }

    .treeRight {
      flex: 1;
      overflow: hidden;

      .treeItem {
        margin-right: 20px;
        float: left;
        padding: 4px 6px;
      }

      .treeActiveItem {
        margin-right: 20px;
        float: left;
        padding: 4px 6px;
        // background: $mainColor;
        // color: #fff;
        color: $mainColor;
      }
    }
  }
}

.searchView {
  margin: 10px;
}
.listBox {
  ::v-deep .column {
    display: flex;
    justify-content: space-around;
    flex-direction: column-reverse;
  }
}
</style>
